export const withErrorHandler =
  (fn) =>
  async (...args) => {
    try {
      return await fn(...args);
    } catch (error) {
      console.error("Caught error:", error);
      // You can trigger a toast or log the error here
    }
  };
